// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../Scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../Scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accountsDropdown {
    margin-bottom: 15px;
    margin-top: 15px;
    font-family: Arial, sans-serif;
    min-width: 0px;
}

.accountContainer {
    position: relative;
    display: inline-block;
    width: 100%;
}

.dropdown .selected {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
}

    .dropdown .selected:hover {
        border-color: #555;
    }

.arrow {
    border: solid #888;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.dropdownMenu {
    max-height: 400px;
    overflow-y: auto;
    display: none;
    position: absolute;
    width: 100%;
    border: 1px solid #ccc;
    border-top: none;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 2;
    background-color: #fff;
}

    .dropdownMenu.show {
        display: block;
    }

.dropdownItem {
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
}

    .dropdownItem:hover {
        background-color: #f1f1f1;
    }

    .dropdownItem:hover {
        background-color: #bde4ff;
    }

    .dropdownItem.highlighted,
    .selectedOption {
        background-color: #bde4ff;
        color: #333;
    }

    .dropdownItem.highlighted {
        box-shadow: 0 0 0.2rem 0.2rem rgb(172 186 187);
    }

.dropdown.disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
}

.dropdown-refresh-wrap {
    position: relative;
}

.dropdown-refresh-spinner {
    position: absolute;
    top: 50%;
    right: 32px;
    transform: translateY(-50%);
    color: #888;
    pointer-events: none;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}

.stateDropdown {
    position: relative;
    width: 140px;
    flex-shrink: 0;
}

.accountDropdown {
    position: relative;
    flex: 0 0 auto;
    max-width: 480px;
}

.dropdownsRow {
    display: flex;
    gap: 12px;
    align-items: center;
}

.accountDropdown .selected {
    width: auto;
    min-width: 160px;
    justify-content: flex-start;
    gap: 12px;
    padding-right: 14px;
}

.accountDropdown .dropdownMenu {
    min-width: 100%;
    width: max-content;
    max-width: 480px;
}`, "",{"version":3,"sources":["webpack://./../Styles/Dropdown.1.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;IAEI;QACI,kBAAkB;IACtB;;AAEJ;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,wBAAwB;IACxB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,+CAA+C;IAC/C,UAAU;IACV,sBAAsB;AAC1B;;IAEI;QACI,cAAc;IAClB;;AAEJ;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;IAEI;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,yBAAyB;QACzB,WAAW;IACf;;IAEA;QACI,8CAA8C;IAClD;;AAEJ;IACI,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".accountsDropdown {\r\n    margin-bottom: 15px;\r\n    margin-top: 15px;\r\n    font-family: Arial, sans-serif;\r\n    min-width: 0px;\r\n}\r\n\r\n.accountContainer {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n.dropdown .selected {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    background-color: #fff;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    user-select: none;\r\n}\r\n\r\n    .dropdown .selected:hover {\r\n        border-color: #555;\r\n    }\r\n\r\n.arrow {\r\n    border: solid #888;\r\n    border-width: 0 3px 3px 0;\r\n    display: inline-block;\r\n    padding: 3px;\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n}\r\n\r\n.dropdownMenu {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    display: none;\r\n    position: absolute;\r\n    width: 100%;\r\n    border: 1px solid #ccc;\r\n    border-top: none;\r\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\r\n    z-index: 2;\r\n    background-color: #fff;\r\n}\r\n\r\n    .dropdownMenu.show {\r\n        display: block;\r\n    }\r\n\r\n.dropdownItem {\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n}\r\n\r\n    .dropdownItem:hover {\r\n        background-color: #f1f1f1;\r\n    }\r\n\r\n    .dropdownItem:hover {\r\n        background-color: #bde4ff;\r\n    }\r\n\r\n    .dropdownItem.highlighted,\r\n    .selectedOption {\r\n        background-color: #bde4ff;\r\n        color: #333;\r\n    }\r\n\r\n    .dropdownItem.highlighted {\r\n        box-shadow: 0 0 0.2rem 0.2rem rgb(172 186 187);\r\n    }\r\n\r\n.dropdown.disabled {\r\n    pointer-events: none;\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.dropdown-refresh-wrap {\r\n    position: relative;\r\n}\r\n\r\n.dropdown-refresh-spinner {\r\n    position: absolute;\r\n    top: 50%;\r\n    right: 32px;\r\n    transform: translateY(-50%);\r\n    color: #888;\r\n    pointer-events: none;\r\n}\r\n\r\n.sr-only {\r\n    position: absolute;\r\n    width: 1px;\r\n    height: 1px;\r\n    padding: 0;\r\n    margin: -1px;\r\n    overflow: hidden;\r\n    clip: rect(0, 0, 0, 0);\r\n    border: 0;\r\n}\r\n\r\n.stateDropdown {\r\n    position: relative;\r\n    width: 140px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.accountDropdown {\r\n    position: relative;\r\n    flex: 0 0 auto;\r\n    max-width: 480px;\r\n}\r\n\r\n.dropdownsRow {\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n}\r\n\r\n.accountDropdown .selected {\r\n    width: auto;\r\n    min-width: 160px;\r\n    justify-content: flex-start;\r\n    gap: 12px;\r\n    padding-right: 14px;\r\n}\r\n\r\n.accountDropdown .dropdownMenu {\r\n    min-width: 100%;\r\n    width: max-content;\r\n    max-width: 480px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
